import { httpClient, HttpError } from '../core/http';
import { AppEmbedKey, EmbedKeyCreateRequest, EmbedTokenIssueRequest } from '../types';

type EmbedTokenIssueResponse = {
  token: string;
};

const toHttpError = (error: unknown): HttpError => {
  if (error && typeof error === 'object' && 'message' in error) {
    return error as HttpError;
  }
  return { message: 'Erro desconhecido ao processar embed.' };
};

export class EmbedKeyService {
  private readonly basePath = '/v1/tools';

  async listKeys(toolId: string): Promise<AppEmbedKey[]> {
    try {
      const response = await httpClient.get<{ items?: AppEmbedKey[] } | AppEmbedKey[]>(
        `${this.basePath}/${toolId}/embed/keys`
      );
      if (Array.isArray(response.data)) {
        return response.data;
      }
      return response.data.items || [];
    } catch (error) {
      const httpError = toHttpError(error);
      // Backward compatibility: backend may not expose this GET yet.
      if (httpError.status === 404 || httpError.status === 405) {
        return [];
      }
      throw httpError;
    }
  }

  async createKey(toolId: string, payload: EmbedKeyCreateRequest): Promise<AppEmbedKey> {
    const response = await httpClient.post<AppEmbedKey>(
      `${this.basePath}/${toolId}/embed/keys`,
      payload
    );
    return response.data;
  }

  async issueToken(
    toolId: string,
    payload: EmbedTokenIssueRequest
  ): Promise<EmbedTokenIssueResponse> {
    const response = await httpClient.post<EmbedTokenIssueResponse>(
      `${this.basePath}/${toolId}/embed/tokens`,
      payload
    );
    return response.data;
  }
}

export const embedKeyService = new EmbedKeyService();
